
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBarVertical as ObcBarVerticalElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/bar-vertical/bar-vertical.js';
 
 
 

 
 export const ObcBarVertical = createComponent({
   react: React,
   tagName: 'obc-bar-vertical',
   elementClass: ObcBarVerticalElement,
   events: {
     
   }
  });
 
 